// Fechas de custom forms: display dd/mm/yyyy, valor interno YYYY-MM-DD (o epoch ms).

const pad = (n) => String(n).padStart(2, '0')

const isRealDate = (year, month, day) => {
  if (year < 1000 || month < 1 || month > 12 || day < 1) return false
  const date = new Date(year, month - 1, day)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

/** YYYY-MM-DD o dd/mm/yyyy → YYYY-MM-DD, o '' si inválido. */
export const toISODate = (value) => {
  if (value == null || value === '') return ''
  if (typeof value === 'number' && Number.isFinite(value)) {
    const d = new Date(value)
    if (Number.isNaN(d.getTime())) return ''
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
  }
  const trimmed = String(value).trim()
  const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/)
  if (iso) {
    const [, y, m, d] = iso
    return isRealDate(+y, +m, +d) ? `${y}-${m}-${d}` : ''
  }
  const dmy = trimmed.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/)
  if (dmy) {
    const [, d, m, y] = dmy
    if (!isRealDate(+y, +m, +d)) return ''
    return `${y}-${pad(+m)}-${pad(+d)}`
  }
  // 15022026 → 15/02/2026
  const compact = trimmed.replace(/\D/g, '')
  if (compact.length === 8) {
    const d = +compact.slice(0, 2)
    const m = +compact.slice(2, 4)
    const y = +compact.slice(4, 8)
    if (!isRealDate(y, m, d)) return ''
    return `${y}-${pad(m)}-${pad(d)}`
  }
  return ''
}

/** Solo dígitos → máscara dd/mm/yyyy mientras se escribe (máx 8 dígitos). */
export const maskDateDigits = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

/** YYYY-MM-DD o epoch → dd/mm/yyyy para mostrar. */
export const toDisplayDate = (value) => {
  const iso = toISODate(value)
  if (!iso) return typeof value === 'string' ? value : ''
  const [y, m, d] = iso.split('-')
  return `${d}/${m}/${y}`
}

/** dd/mm/yyyy o ISO → epoch ms (inicio del día local), o null. */
export const toEpoch = (value) => {
  const iso = toISODate(value)
  if (!iso) return null
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d).getTime()
}
